import { render, staticRenderFns } from "./newPermissionGroup.vue?vue&type=template&id=43e3059e&scoped=true&"
import script from "./newPermissionGroup.vue?vue&type=script&lang=ts&"
export * from "./newPermissionGroup.vue?vue&type=script&lang=ts&"
import style0 from "./newPermissionGroup.vue?vue&type=style&index=0&id=43e3059e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e3059e",
  null
  
)

export default component.exports